import Vue from 'vue';

window.Vue = Vue;
window._ = require('lodash');
require('sweetalert');
require('./css-grid-polyfill');

require('./sticky');
require('./menu');
require('./contact');
require('./modal');
require('./faq');

import 'simplebar';
import 'simplebar/dist/simplebar.css';
